import * as Yup from 'yup'

const exceptionalDateValidator = Yup.object ({
  professionals: Yup.array ().of (
    Yup.object ()
  ).min (1, 'Selecione um profissional'),

  description: Yup
    .string ()
    .required ('Selecione uma descrição'),

  startDate: Yup
    .string ()
    .required ('Selecione uma data de início'),

  endDate: Yup
    .string ()
    .required ('Selecione uma data final')
    .test (
      'is-greater-or-equal',
      'A data final deve ser maior ou igual à data inicial.',
      function (value) {
        const { startDate } = this.parent
        if (!startDate || !value) return true
        return value >= startDate
      }
    ),
  
  period: Yup
    .object ()
    .nullable ()
    .required ('Selecione um período'),

  startTime: Yup
    .object ()
    .nullable ()
    .required ('Selecione o horário inicial'),

  endTime: Yup
    .object ()
    .nullable ()
    .required ('Selecione o horário final')
})

export default exceptionalDateValidator
